import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import AppHeader from "@/layouts/AppHeader";
import WhatsAppFab from "@/components/WhatsAppFab";
import Sitemap from "@/components/Sitemap";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Award } from "lucide-react";
import { AppFooter } from "@/layouts/AppFooter";
import { Helmet } from "react-helmet-async";
import { useRegion } from "@/context/RegionContext";

// Define TypeScript interfaces for the API response
interface PageData {
  id: number;
  title: string;
  slug: string;
  short_description: string;
  content: string;
  image_path: string | null;
  created_at: string;
  updated_at: string;
}

const PaymentCancelPage: React.FC = () => {
  const { region } = useRegion();

  return (
    <>
      <WhatsAppFab />
      <Helmet>
        <title>Europcar {region.countryName}: Payment failed</title>
        <meta name="description" content={region.seoDescription} />
        <meta name="keywords" content={region.seoKeywords} data-hid="keywords"/>
    </Helmet>
      <AppHeader
        className="bg-neutral-100 pb-4 px-4 md:px-32 relative w-full z-30"
        textColor="text-black"
        borderColor="border-black"

      />

<main className="relative flex flex-1 flex-col overflow-hidden px-4 py-8 sm:px-6 lg:px-8">
   <img src="/plus/img/beams-cover@95.jpg" alt="" className="absolute top-0 left-1/2 -ml-[47.5rem] w-[122.5rem] max-w-none"/>
   <div className="absolute inset-0 text-slate-900/[0.07] [mask-image:linear-gradient(to_bottom_left,white,transparent,transparent)]">
      <svg className="absolute inset-0 h-full w-full" xmlns="http://www.w3.org/2000/svg">
         <defs>
            <pattern id="grid-bg" width="32" height="32" patternUnits="userSpaceOnUse" x="100%" patternTransform="translate(0 -1)">
               <path d="M0 32V.5H32" fill="none" stroke="currentColor"></path>
            </pattern>
         </defs>
         <rect width="100%" height="100%" fill="url(#grid-bg)"></rect>
      </svg>
   </div>
   <div className="relative flex flex-1 flex-col items-center justify-center pt-32 pb-40">

      <div className="max-w-2xl text-center">
         <h1 className="text-3xl font-extrabold text-slate-900 sm:text-4xl">We’re Sorry to See You Go..</h1>
         <div className="mt-6 text-base/7 text-slate-600">
         It looks like your payment didn’t go through. We understand that plans can change..
         </div>
         <a className="inline-flex justify-center rounded-lg text-sm font-semibold py-2.5 px-4 bg-green-600 text-white hover:bg-green-700 mt-6" href="/"><span>Back to home page</span></a>
      </div>
   </div>

</main>
<AppFooter/>
    </>
  );
};

export default PaymentCancelPage;